import type { ReactNode } from 'react';

type Props = {
	children: ReactNode;
	className?: string;
};

export default function SectionTitle({ children, className }: Props) {
	return <h2 className={`text-5xl max-lg:text-4xl font-bold ${className}`}>{children}</h2>;
}
